export default __webpack_public_path__ + "static/media/logo_img.d9608f8f.png";